import { render, staticRenderFns } from "./CorTable.vue?vue&type=template&id=462fd767"
import script from "./CorTable.vue?vue&type=script&lang=ts"
export * from "./CorTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports